module.exports = __webpack_public_path__ + "img/retro_sec4.be1bc2a0.jpg";